
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"filter":"url(#filter0_d_2937_403)"}},[_c('circle',{attrs:{"cx":"25","cy":"23","r":"19","fill":"#fff"}})]),_c('path',{attrs:{"d":"M33 33H17v-1.905a4.65 4.65 0 011.465-3.367A5.13 5.13 0 0122 26.333h6a5.13 5.13 0 013.535 1.395A4.65 4.65 0 0133 31.095V33zm-8-8.571a6.261 6.261 0 01-2.296-.435 6.028 6.028 0 01-1.947-1.24c-.557-.53-.999-1.16-1.3-1.853A5.479 5.479 0 0119 18.714c0-.75.155-1.493.457-2.186a5.704 5.704 0 011.3-1.854 6.026 6.026 0 011.947-1.239A6.261 6.261 0 0125 13c1.591 0 3.117.602 4.243 1.674C30.368 15.745 31 17.199 31 18.714c0 1.516-.632 2.97-1.757 4.04A6.156 6.156 0 0125 24.43z","fill":"#06F"}}),_c('defs',[_c('filter',{attrs:{"id":"filter0_d_2937_403","x":"0","y":"0","width":"50","height":"50","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feColorMatrix',{attrs:{"in":"SourceAlpha","values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0","result":"hardAlpha"}}),_c('feOffset',{attrs:{"dy":"2"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"3"}}),_c('feComposite',{attrs:{"in2":"hardAlpha","operator":"out"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"}}),_c('feBlend',{attrs:{"in2":"BackgroundImageFix","result":"effect1_dropShadow_2937_403"}}),_c('feBlend',{attrs:{"in":"SourceGraphic","in2":"effect1_dropShadow_2937_403","result":"shape"}})])])])
          )
        }
      }
    